import styled from 'styled-components'
import ProductionCompany from './ProductionCompany';

const CompaniesContainer = styled.div`
  display: flex;
`

const ProductionCompaniesContainer = ({companies}) => {
  return(
    <CompaniesContainer>
      {companies.length > 0 &&
        companies.map((company, index) => (
          <ProductionCompany
            name={company.name}
            address1={company.address1}
            address2={company.address2}
            city={company.city}
            stateProv={company.stateProv}
            zipCode={company.zipCode}
            length={companies.length}
            key={index}
          />
        ))
      }
    </CompaniesContainer>
  )
}

export default ProductionCompaniesContainer;
